import { render, staticRenderFns } from "./BasicText.vue?vue&type=template&id=5b803e93&scoped=true"
import script from "./BasicText.vue?vue&type=script&lang=js"
export * from "./BasicText.vue?vue&type=script&lang=js"
import style0 from "./BasicText.vue?vue&type=style&index=0&id=5b803e93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b803e93",
  null
  
)

export default component.exports